import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { useReveal } from './Reveal';
import { CHAPELLE_STEPS } from '../data/science';

// Four-step process infographic for the modified Chapelle test.
const ChapelleInfographic = () => {
  const { lang } = useLang();
  const { ref, visible } = useReveal({ threshold: 0.15 });

  return (
    <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="chapelle-infographic">
      {CHAPELLE_STEPS.map((step, i) => (
        <div key={i} className="relative">
          <div
            className="h-full rounded-xl border border-slate-200 bg-white p-5"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'none' : 'translateY(10px)',
              transition: `opacity 0.5s ease ${i * 90}ms, transform 0.5s ease ${i * 90}ms`,
            }}
          >
            <div className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-blue-700 text-white text-[15px] font-bold">
              {i + 1}
            </div>
            <p className="mt-3 text-[14px] font-bold text-slate-900">{step.title[lang]}</p>
            <p className="mt-1.5 text-[13px] text-slate-600 leading-relaxed">{step.text[lang]}</p>
          </div>
          {i < CHAPELLE_STEPS.length - 1 && (
            <ArrowRight className="hidden lg:block absolute top-1/2 -right-3 -translate-y-1/2 w-5 h-5 text-slate-300" aria-hidden="true" />
          )}
        </div>
      ))}
    </div>
  );
};

export default ChapelleInfographic;
